// src/components/screener/CSVGate.jsx
// Extracted from ScreenerPage.jsx (SCREENER-FRAG) — content unchanged, location only.

import React from 'react';
import { S } from '../../constants/screenerConfig';

// ── CSV gate for guests ───────────────────────────────────────
export default function CSVGate({ onRequestInvite }) {
  return (
    <div style={{
      padding: '10px 16px', background: S.surface,
      border: `1px solid ${S.border2}`, borderRadius: 8,
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
    }}>
      <span style={{ fontSize: 13, color: S.muted, flex: 1 }}>
        💾 CSV export available for members
      </span>
      <button
        onClick={onRequestInvite}
        style={{
          padding: '6px 16px', borderRadius: 6,
          border: `1px solid ${S.purple}`, background: 'transparent',
          color: S.purple, fontSize: 12, fontWeight: 700,
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >
        Request Invite
      </button>
    </div>
  );
}
